module.exports = __webpack_public_path__ + "img/status-true.e6a2d8e6.svg";